import {HeaderActionButton} from "../HeaderActionButton";
import {MenuItem} from "@mui/material";
import {Popover} from "../../../../misc/Popover";
import {useState} from "react";
import ViewListIcon from "@mui/icons-material/ViewList";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import {useQueryParam} from "../../quote/pricing/QueryParam";

export type LogisticsView = "default" | "release";

export function useLogisticsView() {
    return useQueryParam<LogisticsView>("view", "default");
}

export function ViewButton(props: {
    value: LogisticsView;
    onChange(value: LogisticsView): void;
}) {
    const [anchor, setAnchor] = useState<HTMLElement|null>(null);

    return (
        <>
            <HeaderActionButton
                label="View"
                icon={props.value === "release" ? <RocketLaunchIcon fontSize="inherit" /> : <ViewListIcon fontSize="inherit" />}
                badgeContent={props.value === "release" ? "Release" : null}
                badgeColor="primary"
                onClick={e => setAnchor(e.currentTarget)}
            />
            {anchor && <Popover open anchorEl={anchor} onClose={() => setAnchor(null)}>
                <MenuItem selected={props.value === "default"} onClick={() => {
                    props.onChange("default");
                    setAnchor(null);
                }}>Default</MenuItem>
                <MenuItem selected={props.value === "release"} onClick={() => {
                    props.onChange("release");
                    setAnchor(null);
                }}>Release</MenuItem>
            </Popover>}
        </>
    )
}
